import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import type {DateRange} from "../../common/newDatePicker/datePickerShared";
import {RightSidebarActionButton} from "../../layout/rightSidebar/RightSidebarRail";
import {surveyInvitationsLink} from "../shared/surveyListLinks";

export default function SurveyInvitationsRailButton({range}: {range: DateRange}) {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <RightSidebarActionButton
            icon={<ForwardToInboxOutlinedIcon/>}
            label={t("View invitations")}
            onClick={() => navigate(surveyInvitationsLink({range, withoutVoided: true}))}
        />
    );
}
